import { authClient, API } from '../index'

export const getFormsAdmin = () => {
  return authClient().get(`${API}/forms/admin`)
}

export const getFormById = (id) => {
  return authClient().get(`${API}/forms/${id}`)
}

export const postForm = (data) => {
  return authClient().post(`${API}/forms`, data)
}

export const updateForm = (id, data) => {
  return authClient().put(`${API}/forms/${id}`, data)
}

export const deleteForm = (id) => {
  return authClient().delete(`${API}/forms/${id}`)
}
